module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "tree-box resizable",
    style: ({
      width: width + 'px'
    }),
    on: {
      "click": function($event) {
        $emit('click')
      }
    }
  }, [_h('resizer', {
    attrs: {
      "type": "vertical"
    },
    on: {
      "resizer:begin": onResizeBegin,
      "resizer:resize": onResize
    }
  }), " ", _h('div', {
    staticClass: "box-header"
  }, [_h('div', {
    staticClass: "box-title"
  }, [_s(showAssembly ? 'Assembly' : 'Syntax Tree')]), " ", _h('span', {
    staticClass: "box-caret glyphicon glyphicon-menu-right",
    on: {
      "click": function($event) {
        $emit('parse-tree:close')
      }
    }
  })]), " ", _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!showAssembly),
      expression: "!showAssembly"
    }],
    ref: "boxBody",
    staticClass: "box-body",
    attrs: {
      "id": "tree-pane"
    }
  }, [_m(0)]), " ", _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (showAssembly),
      expression: "showAssembly"
    }],
    staticClass: "box-body",
    attrs: {
      "id": "assembly-pane"
    }
  }, [_m(1), " ", _h('textarea', {
    ref: "textarea",
    attrs: {
      "id": "assembly"
    }
  })])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "placeholder"
  }, ["Nothing to show"])
}},function (){with(this) {
  return _h('div', {
    attrs: {
      "style": "float: left;height: 100%;width: 18px;background: rgb(60, 63, 65)"
    }
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-61c5b76b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ParseTree.vue
 ** module id = 131
 ** module chunks = 2
 **/